/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT edit this file manually. Run `tsr generate` to regenerate.
// For now, this is a hand-written route tree that mirrors file-based routing.

import { Route as rootRoute } from './routes/__root';
import { coreChildren } from './routeTrees/core';
import { galleryChildren } from './routeTrees/gallery';
import { mobileChildren } from './routeTrees/mobile';
import { ownerChildren } from './routeTrees/owner';
import { passportChildren } from './routeTrees/passport';

export const routeTree = rootRoute.addChildren({
  ...coreChildren,
  ...ownerChildren,
  ...passportChildren,
  ...galleryChildren,
  ...mobileChildren,
});
